import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "contributor-covenant-code-of-conduct"
    }}>{`Contributor Covenant Code of Conduct`}</h1>
    <h2 {...{
      "id": "our-pledge"
    }}>{`Our Pledge`}</h2>
    <p>{`We as members, contributors, and leaders pledge to make participation in our
community a harassment-free experience for everyone, regardless of age, body
size, visible or invisible disability, ethnicity, sex characteristics, gender
identity and expression, level of experience, education, socio-economic status,
nationality, personal appearance, race, religion, or sexual identity
and orientation.`}</p>
    <p>{`We pledge to act and interact in ways that contribute to an open, welcoming,
diverse, inclusive, and healthy community.`}</p>
    <h2 {...{
      "id": "our-standards"
    }}>{`Our Standards`}</h2>
    <p>{`Examples of behavior that contributes to a positive environment for our
community include:`}</p>
    <ul>
      <li parentName="ul">{`Demonstrating empathy and kindness toward other people`}</li>
      <li parentName="ul">{`Being respectful of differing opinions, viewpoints, and experiences`}</li>
      <li parentName="ul">{`Giving and gracefully accepting constructive feedback`}</li>
      <li parentName="ul">{`Accepting responsibility and apologizing to those affected by our mistakes,
and learning from the experience`}</li>
      <li parentName="ul">{`Focusing on what is best not just for us as individuals, but for the
overall community`}</li>
    </ul>
    <p>{`Examples of unacceptable behavior include:`}</p>
    <ul>
      <li parentName="ul">{`The use of sexualized language or imagery, and sexual attention or
advances of any kind`}</li>
      <li parentName="ul">{`Trolling, insulting or derogatory comments, and personal or political attacks`}</li>
      <li parentName="ul">{`Public or private harassment`}</li>
      <li parentName="ul">{`Publishing others' private information, such as a physical or email
address, without their explicit permission`}</li>
      <li parentName="ul">{`Other conduct which could reasonably be considered inappropriate in a
professional setting`}</li>
    </ul>
    <h2 {...{
      "id": "enforcement-responsibilities"
    }}>{`Enforcement Responsibilities`}</h2>
    <p>{`Community leaders are responsible for clarifying and enforcing our standards of
acceptable behavior and will take appropriate and fair corrective action in
response to any behavior that they deem inappropriate, threatening, offensive,
or harmful.`}</p>
    <p>{`Community leaders have the right and responsibility to remove, edit, or reject
comments, commits, code, wiki edits, issues, and other contributions that are
not aligned to this Code of Conduct, and will communicate reasons for moderation
decisions when appropriate.`}</p>
    <h2 {...{
      "id": "scope"
    }}>{`Scope`}</h2>
    <p>{`This Code of Conduct applies within all community spaces, and also applies when
an individual is officially representing the community in public spaces.
Examples of representing our community include using an official e-mail address,
posting via an official social media account, or acting as an appointed
representative at an online or offline event.`}</p>
    <h2 {...{
      "id": "enforcement"
    }}>{`Enforcement`}</h2>
    <p>{`Instances of abusive, harassing, or otherwise unacceptable behavior may be
reported to the community leaders responsible for enforcement at
`}<a parentName="p" {...{
        "href": "mailto:tapas.adhikary@gmail.com."
      }}>{`tapas.adhikary@gmail.com.`}</a>{`
All complaints will be reviewed and investigated promptly and fairly.`}</p>
    <p>{`All community leaders are obligated to respect the privacy and security of the
reporter of any incident.`}</p>
    <h2 {...{
      "id": "enforcement-guidelines"
    }}>{`Enforcement Guidelines`}</h2>
    <p>{`Community leaders will follow these Community Impact Guidelines in determining
the consequences for any action they deem in violation of this Code of Conduct:`}</p>
    <h3 {...{
      "id": "1-correction"
    }}>{`1. Correction`}</h3>
    <p><strong parentName="p">{`Community Impact`}</strong>{`: Use of inappropriate language or other behavior deemed
unprofessional or unwelcome in the community.`}</p>
    <p><strong parentName="p">{`Consequence`}</strong>{`: A private, written warning from community leaders, providing
clarity around the nature of the violation and an explanation of why the
behavior was inappropriate. A public apology may be requested.`}</p>
    <h3 {...{
      "id": "2-warning"
    }}>{`2. Warning`}</h3>
    <p><strong parentName="p">{`Community Impact`}</strong>{`: A violation through a single incident or series
of actions.`}</p>
    <p><strong parentName="p">{`Consequence`}</strong>{`: A warning with consequences for continued behavior. No
interaction with the people involved, including unsolicited interaction with
those enforcing the Code of Conduct, for a specified period of time. This
includes avoiding interactions in community spaces as well as external channels
like social media. Violating these terms may lead to a temporary or
permanent ban.`}</p>
    <h3 {...{
      "id": "3-temporary-ban"
    }}>{`3. Temporary Ban`}</h3>
    <p><strong parentName="p">{`Community Impact`}</strong>{`: A serious violation of community standards, including
sustained inappropriate behavior.`}</p>
    <p><strong parentName="p">{`Consequence`}</strong>{`: A temporary ban from any sort of interaction or public
communication with the community for a specified period of time. No public or
private interaction with the people involved, including unsolicited interaction
with those enforcing the Code of Conduct, is allowed during this period.
Violating these terms may lead to a permanent ban.`}</p>
    <h3 {...{
      "id": "4-permanent-ban"
    }}>{`4. Permanent Ban`}</h3>
    <p><strong parentName="p">{`Community Impact`}</strong>{`: Demonstrating a pattern of violation of community
standards, including sustained inappropriate behavior,  harassment of an
individual, or aggression toward or disparagement of classes of individuals.`}</p>
    <p><strong parentName="p">{`Consequence`}</strong>{`: A permanent ban from any sort of public interaction within
the community.`}</p>
    <h2 {...{
      "id": "attribution"
    }}>{`Attribution`}</h2>
    <p>{`This Code of Conduct is adapted from the `}<a parentName="p" {...{
        "href": "https://www.contributor-covenant.org"
      }}>{`Contributor Covenant`}</a>{`,
version 2.0, available at
`}<a parentName="p" {...{
        "href": "https://www.contributor-covenant.org/version/2/0/code_of_conduct.html"
      }}>{`https://www.contributor-covenant.org/version/2/0/code_of_conduct.html`}</a>{`.`}</p>
    <p>{`Community Impact Guidelines were inspired by `}<a parentName="p" {...{
        "href": "https://github.com/mozilla/diversity"
      }}>{`Mozilla's code of conduct
enforcement ladder`}</a>{`.`}</p>
    <p>{`For answers to common questions about this code of conduct, see the FAQ at
`}<a parentName="p" {...{
        "href": "https://www.contributor-covenant.org/faq"
      }}>{`https://www.contributor-covenant.org/faq`}</a>{`. Translations are available at
`}<a parentName="p" {...{
        "href": "https://www.contributor-covenant.org/translations"
      }}>{`https://www.contributor-covenant.org/translations`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      